import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatusMessage('');

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('subject', formData.subject);
        formDataToSend.append('message', formData.message);

        try {
            const response = await fetch('/forms/contact.php', {
                method: 'POST',
                body: formDataToSend
            });

            // Check if response is ok
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Get the response text first
            const responseText = await response.text();

            // Check if response is empty
            if (!responseText || responseText.trim() === '') {
                throw new Error('Server returned empty response');
            }

            // Try to parse JSON
            let result;
            try {
                result = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error:', jsonError);
                console.error('Response that failed to parse:', responseText);
                throw new Error('Server returned invalid JSON response: ' + responseText.substring(0, 100));
            }

            if (result.success) {
                setMessageType('success');
                setStatusMessage(result.message);
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else {
                setMessageType('error');
                setStatusMessage(result.message);
            }
        } catch (error) {
            setMessageType('error');
            setStatusMessage(`Error: ${error.message}. Please check the console for details.`);
            console.error('Contact form error:', error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <section id="contact" className="contact-section py-5">
            <div className="container" data-aos="fade-up">
                {/* Section Header */}
                <div className="text-center mb-5">
                    <h2 className="section-title fw-bold">Get in Touch</h2>
                    <p className="section-subtitle text-muted">
                        We’re here to help you with your digital transformation.
                        Reach out to Anmatics Technologies and let’s build something amazing together.
                    </p>
                </div>

                <div className="row g-4">
                    {/* Office Locations */}
                    <div className="col-lg-6">
                        <div className="contact-card shadow-sm p-4 h-100 bg-white rounded-4">
                            <h5 className="fw-bold mb-3 text-gradient">Our Offices</h5>
                            <ul className="list-unstyled">
                                 <li className="mb-4">
                                    <div className="fw-semibold mb-1">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 contact-icon" /> Head Office - Rajkot
                                    </div>
                                    <p className="mb-0 text-muted">
                                        203, Ikon Complex, Opp. Sun City Apartment,<br />
                                        Sadhu Vaswani Road, Rajkot - 360005, India
                                    </p>
                                </li>
                                <li>
                                    <div className="fw-semibold mb-1">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 contact-icon" /> Branch Office - Morbi
                                    </div>
                                    <p className="mb-0 text-muted">
                                        207, Second Floor, City Mall, Nr. Bhaktinagar Bypass,<br />
                                        Sanala Road, Morbi, Gujarat - 363641, India
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Contact Info + Form */}
                    <div className="col-lg-6">
                        <div className="contact-card shadow-sm p-4 bg-white rounded-4">
                            <h5 className="fw-bold mb-3 text-gradient">Contact Information</h5>
                            <ul className="list-unstyled mb-4">
                                <li className="mb-2">
                                    <FontAwesomeIcon icon={faEnvelope} className="me-2 contact-icon" />
                                    <a href="mailto:chandrakant.namera@anmatics.com" className="text-decoration-none text-dark fw-semibold">
                                        chandrakant.namera@anmatics.com
                                    </a>
                                </li>
                                <li>
                                    <FontAwesomeIcon icon={faPhone} className="me-2 contact-icon" />
                                    <a href="tel:+918866899005" className="text-decoration-none text-dark fw-semibold">
                                        +91 88668 99005
                                    </a>
                                </li>
                            </ul>

                            <h5 className="fw-bold mb-3 text-gradient">Send Us a Message</h5>
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            placeholder="Your Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            placeholder="Your Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="subject"
                                            placeholder="Subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-12">
                                        <textarea
                                            className="form-control"
                                            name="message"
                                            rows="4"
                                            placeholder="Your Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="text-center mt-4">
                                    <button type="submit" className="btn btn-gradient px-4 py-2 rounded-pill" disabled={isLoading}>
                                        {isLoading ? 'Sending...' : 'Send Message'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Status Message */}
                {statusMessage && (
                    <div className={`alert mt-4 text-center ${messageType === 'success' ? 'alert-success' : 'alert-danger'}`}>
                        {statusMessage}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Contact;
